import graphqlClient from "../../../apollo";

class UserPermissionProvider {

    findUserPermission(userId, companyId) {
        return graphqlClient.query({
            query: require('./gql/adminUserPermissionFind.graphql'),
            variables: { userId, companyId },
            fetchPolicy: "network-only"
        })
    }

    fetchByCompany(companyId) {
        return graphqlClient.query({
            query: require('./gql/adminUserPermissionFetchByCompany.graphql'),
            variables: { companyId },
            fetchPolicy: "network-only"
        })
    }

    upsertUserPermission(userId, companyId, input) {
        return graphqlClient.mutate({
            mutation: require('./gql/adminUserPermissionUpsert.graphql'),
            variables: { userId, companyId, input }
        })
    }

    deleteUserPermission(userId, companyId) {
        return graphqlClient.mutate({
            mutation: require('./gql/adminUserPermissionDelete.graphql'),
            variables: { userId, companyId }
        })
    }
}

export default new UserPermissionProvider()
